export default {"src":"/_next/static/media/alert-triangle.f3528abe.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};